module.exports = __webpack_public_path__ + "assets/img/zyhtLogoIndex.564047c0.png";